var DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';

export { DEFAULT_DATE_FORMAT };
//# sourceMappingURL=defaultDateFormat.js.map
